var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNormalChevronBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "6px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 9.4392523364486,
    y1: -1.998401444325282e-16,
    x2: -0.1869158878504784,
    y2: -1.998401444325282e-16,
    id: "LinearGradient664"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "Stop665",
    stopColor: "#a1e8af",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "Stop666",
    stopColor: "#32936f",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -74 -38 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.899799599198397 0.6185567010309276  C 9.966599866399466 0.6872852233676958  10 0.7663230240549821  10 0.8556701030927838  C 10 0.9450171821305835  9.966599866399466 1.0240549828178684  9.899799599198397 1.0927835051546393  L 5.230460921843687 5.896907216494845  C 5.163660654642619 5.9656357388316135  5.08684034736139 6  5 6  C 4.913159652638611 6  4.836339345357382 5.9656357388316135  4.7695390781563125 5.896907216494845  L 0.1002004008016032 1.0927835051546393  C 0.033400133600534496 1.0240549828178684  0 0.9450171821305835  0 0.8556701030927838  C 0 0.7663230240549821  0.033400133600534496 0.6872852233676958  0.1002004008016032 0.6185567010309276  L 0.6012024048096192 0.10309278350515494  C 0.6680026720106882 0.03436426116838409  0.7448229792919172 0  0.8316633266533067 0  C 0.9185036740146962 0  0.9953239812959253 0.03436426116838409  1.062124248496994 0.10309278350515494  L 5 4.154639175257731  L 8.937875751503006 0.10309278350515494  C 9.004676018704075 0.03436426116838409  9.081496325985304 0  9.168336673346694 0  C 9.255177020708084 0  9.331997327989313 0.03436426116838409  9.39879759519038 0.10309278350515494  L 9.899799599198397 0.6185567010309276  Z ",
    fillRule: "nonzero",
    fill: "url(#LinearGradient664)",
    stroke: "none",
    transform: "matrix(1 0 0 1 74 38 )"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalChevronBooking);
export default __webpack_public_path__ + "static/media/normal_chevron-booking.7e7df827e3d30fba903f81f8467aa3ca.svg";
export { ForwardRef as ReactComponent };